export default "__VITE_ASSET__WthU13WB__"